import { SessionStorageKeys } from '@aglenergy/shared-library';
import { CouponCode } from 'app/shared/models/couponCode.model';

class CouponCodeService {
  public getFromQueryString() {
    return new URLSearchParams(window.location.search).get(SessionStorageKeys.CouponCode);
  }

  public setSessionStorage(couponCode: string): void {
    sessionStorage.setItem(SessionStorageKeys.CouponCode, couponCode);
  }

  public resetSessionStorage(): void {
    sessionStorage.removeItem(SessionStorageKeys.CouponCode);
  }

  public setMultipleCouponSessionStorage(coupon: CouponCode): void {
    const currentSessionStorage = sessionStorage.getItem(SessionStorageKeys.CouponCode);
    if (currentSessionStorage) {
      if (currentSessionStorage.indexOf(coupon.couponCode) === -1) {
        const newSessionObject = `${currentSessionStorage},${coupon.couponCode}`;
        sessionStorage.setItem(SessionStorageKeys.CouponCode, JSON.stringify(newSessionObject));
      }
    } else {
      sessionStorage.setItem(SessionStorageKeys.CouponCode, coupon.couponCode);
    }
  }
}

export const couponCodeService = new CouponCodeService();
